import { createSlice } from '@reduxjs/toolkit';
import { UiState } from 'constants/ui';
import { ExtraServiceOrderStatus } from 'constants/extra-service';
import { stateName } from './constants';
export const initialState = {
  payInMethods: {
    creditCards: [],
    payInMethods: [],
    walletBalance: null,
    selectedPayInMethod: null,
    uiState: UiState.Idle
  },
  orderPayment: {
    configuration: null,
    status: ExtraServiceOrderStatus.Idle,
    auth: {
      embedded: null,
      payInRedirectUrl: null
    },
    error: {
      isKycConfirmationNeeded: false
    }
  }
};

const getPayInMethodsRequest = draft => {
  draft.payInMethods.uiState = UiState.Pending;
};

const getPayInMethodsFailure = draft => {
  draft.payInMethods.uiState = UiState.Failure;
};

const getPayInMethodsSuccess = (draft, action) => {
  draft.payInMethods.uiState = UiState.Success;
  draft.payInMethods.creditCards = action.payload.creditCards;
  draft.payInMethods.payInMethods = action.payload.payInMethods;
  draft.payInMethods.walletBalance = action.payload.walletBalance;
};

const getCreditCardSuccess = (draft, action) => {
  draft.payInMethods.creditCards.push(action.payload.creditCard);
};

const addCreditCardSuccess = (draft, action) => {
  const addedCard = action.payload.creditCard;
  const sameCardIndex = draft.payInMethods.creditCards.findIndex(_ref => {
    let {
      id
    } = _ref;
    return id === addedCard.id;
  });
  const isCardAlreadyInState = sameCardIndex !== -1;

  if (isCardAlreadyInState) {
    draft.payInMethods.creditCards[sameCardIndex] = addedCard;
  } else {
    draft.payInMethods.creditCards.push(addedCard);
  }
};

const setSelectedPayInMethod = (draft, action) => {
  const {
    creditCardId,
    selectedPayInMethodId
  } = action.payload;
  draft.payInMethods.selectedPayInMethod = {
    creditCardId,
    id: selectedPayInMethodId
  };
};

const setErrorMessage = (draft, action) => {
  draft.errorMessage = action.payload.errorMessage;
};

const triggerPaymentAuthWithRedirect = (draft, action) => {
  draft.orderPayment.auth.payInRedirectUrl = action.payload.payInRedirectUrl;
};

const triggerEmbeddedPaymentAuth = (draft, action) => {
  draft.orderPayment.auth.embedded = action.payload;
};

const cancelOrderPaymentAuth = draft => {
  draft.orderPayment.status = ExtraServiceOrderStatus.Idle;
  draft.orderPayment.auth = {
    embedded: null,
    payInRedirectUrl: null
  };
  draft.orderPayment.error = {
    isKycConfirmationNeeded: false
  };
};

const confirmOrderPaymentRequest = draft => {
  draft.orderPayment.status = ExtraServiceOrderStatus.Processing;
  draft.orderPayment.error = {
    isKycConfirmationNeeded: false
  };
};

const confirmOrderPaymentSuccess = draft => {
  draft.orderPayment.status = ExtraServiceOrderStatus.Success;
  draft.orderPayment.auth = {
    embedded: null,
    payInRedirectUrl: null
  };
  draft.orderPayment.error = {
    isKycConfirmationNeeded: false
  };
};

const updateOrderPaymentDataRequest = draft => {
  draft.orderPayment.auth = {
    embedded: null,
    payInRedirectUrl: null
  };
  draft.orderPayment.error = {
    isKycConfirmationNeeded: false
  };
};

const setOrderPaymentErrorMessage = (draft, action) => {
  draft.orderPayment.status = ExtraServiceOrderStatus.Failure;
  draft.orderPayment.auth = {
    embedded: null,
    payInRedirectUrl: null
  };
  draft.orderPayment.error.message = action.payload.errorMessage;
};

const setIsKycConfirmationNeeded = (draft, action) => {
  draft.orderPayment.error.isKycConfirmationNeeded = action.payload.isNeeded;
};

const fetchConfigurationSuccess = (draft, action) => {
  draft.orderPayment.configuration = action.payload.configuration;
};

const fetchConfigurationFailure = (draft, action) => {
  draft.orderPayment.configuration = null;
  draft.orderPayment.status = ExtraServiceOrderStatus.Failure;
  draft.orderPayment.error.message = action.payload.errorMessage;
};

const extraServiceSlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    triggerPaymentAuthWithRedirect,
    triggerEmbeddedPaymentAuth,
    setErrorMessage,
    getCreditCardSuccess,
    addCreditCardSuccess,
    cancelOrderPaymentAuth,
    setSelectedPayInMethod,
    getPayInMethodsRequest,
    getPayInMethodsFailure,
    getPayInMethodsSuccess,
    fetchConfigurationFailure,
    fetchConfigurationSuccess,
    setIsKycConfirmationNeeded,
    confirmOrderPaymentRequest,
    confirmOrderPaymentSuccess,
    setOrderPaymentErrorMessage,
    updateOrderPaymentDataRequest
  }
});
export const {
  actions
} = extraServiceSlice;
export const plug = {
  [stateName]: extraServiceSlice.reducer
};
export default extraServiceSlice.reducer;